import "@babel/polyfill";
import 'expose-loader?$!jquery';
import 'expose-loader?jQuery!jquery';

import { UnifyCore } from './unify-core';
import { UnifyCoreNpm } from './unify-core-npm';
import { UnifyExtendedNpm } from './unify-extended-npm';

import { UnifyConfig } from './unifyconfig';

/**
* @param {object} o object
*/
export class UnifyLoader {
    load(o) {
        this.unifyConfig = new UnifyConfig(o);
        this.exports = {};
        this.loadAll();
        this.exports.setLocalizations(this.unifyConfig.localizations);
        this.exports.appendCookieContactLegalToHeader();
    }

    initialize() {
        var that = this;
        $(function () {
            that.exports.setSystemInformation(that.unifyConfig.systemInformation);
            that.exports.setUserInformation(that.unifyConfig.userInformation);
            that.exports.monitorSession();
            that.exports.monitorNotification();
            that.exports.setGlobalMenu(that.unifyConfig.globalMenu);
        });
    }

    loadCore() {
        var unifyCore = new UnifyCore();
        unifyCore.initialize({
            endpoints: this.unifyConfig.endpoints,
            isATestEnvironment: this.unifyConfig.isATestEnvironment,
            exports: this.exports,
            translations: this.unifyConfig.translations
        }
        );
    }

    loadCoreNpm() {
        var unifyCoreNpm = new UnifyCoreNpm();
        unifyCoreNpm.initialize({
            brandedColors: this.unifyConfig.brandedColors,
            colorScheme: this.unifyConfig.colorScheme,
            exports: this.exports
        });
    }

    loadDataTables() {
        var unifyExtendedNpm = new UnifyExtendedNpm();
        unifyExtendedNpm.initialize({
            brandedColors: this.unifyConfig.brandedColors,
            colorScheme: this.unifyConfig.colorScheme,
            exports: this.exports
        });
        unifyExtendedNpm.loadDataTables();
        this.exports = unifyExtendedNpm.exports;
    }

    loadHighCharts() {
        var unifyExtendedNpm = new UnifyExtendedNpm();
        unifyExtendedNpm.initialize({
            brandedColors: this.unifyConfig.brandedColors,
            colorScheme: this.unifyConfig.colorScheme,
            exports: this.exports
        });
        unifyExtendedNpm.loadHighChart();
    }

    loadRangeSlider() {
        var unifyExtendedNpm = new UnifyExtendedNpm();
        unifyExtendedNpm.initialize({
            brandedColors: this.unifyConfig.brandedColors,
            colorScheme: this.unifyConfig.colorScheme,
            exports: this.exports
        });
        unifyExtendedNpm.loadRangeSlider();
    }

    loadAll() {
        this.loadCore();
        this.loadCoreNpm();

        // the below is optional
        this.loadDataTables();
        this.loadHighCharts();
        this.loadRangeSlider();
    }
}